
import { Component, Vue, Prop } from "vue-property-decorator";


@Component({
    
})
export default class BuildFrameButton extends Vue {

    @Prop()
    disabled!: boolean;

    handleClick() {
        this.$emit('buildNewFrameClick')
    }

}
